import { combineReducers } from 'redux';
import { spawn } from 'redux-saga/effects';

import { CAD_STORE_KEY } from './constants';
import { STATE_KEY as FORM_STATE_KEY } from './service/CADForm/CADForm.constants';
import CADFormReducer from './service/CADForm/CADForm.reducer';
import CADFormSaga from './service/CADForm/CADForm.sagas';
import { STATE_KEY as LIST_STATE_KEY } from './service/CADList/CADList.constants';
import CADListReducer from './service/CADList/CADList.reducer';
import CADListSaga from './service/CADList/CADList.sagas';

function* mainSaga(): Generator {
	yield spawn(CADFormSaga);
	yield spawn(CADListSaga);
}

const store: string = CAD_STORE_KEY; // If I use directly CAD_STORE_KEY below, I got a TS4023 error...check the best way to handle it

export default {
	id: 'cad',
	saga: mainSaga,
	reducer: {
		[store]: combineReducers({
			[FORM_STATE_KEY]: CADFormReducer,
			[LIST_STATE_KEY]: CADListReducer,
		}),
	},
};
